import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, Drawer, Typography } from "@mui/material";
import useResponsive from "../../../utils/hook";
import Scrollbar from "../scrollbar";
import NavSection from "./navsection";
import navConfig from "../../../routing/navs";
import { getActiveUser, UserRoles } from "../../../utils/utils";
import Logo from "../logo";

const DRAWER_WIDTH = 280;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const { permissions} = getActiveUser();
  const isSuperAdmin = [...permissions].find(perm => perm === "*") !== undefined;

  const isDesktop = useResponsive("up", "lg");

  const menus = isSuperAdmin ? navConfig : navConfig.filter(nav => [...permissions,"Logout","Reset Password"].includes(nav.title));

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          mb: 2,
          px: 5,
          py: 5,
          display: "inline-flex",
          background: "#04297A",
          width: "100%",
        }}
      >
        <Logo width={180} height={50} image="logo-white.png" />
      </Box>

      <NavSection
        navConfig={menus}
      />
    </Scrollbar>
  );

  const versionTxt = (
    <Typography variant="body2" align="center" mb={3} color="text.disabled">
      Dashboard  v1.1.0
    </Typography>
  )

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          elevation={4}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
          {versionTxt}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: "background.default",
              borderRightStyle: "dashed",
              boxShadow: 2
            },
          }}
        >
          {renderContent}
          {versionTxt}
        </Drawer>
      )}
    </RootStyle>
  );
}
